<template>
  <div class="cards-sex" id="cards-box">
    <div class="cards-shaw"></div>
    <div class="module-box" :style="{height:height,width:width}">
      <div v-if="showChart" :id="id" class="chart-box" />
      <div v-else class="no-data">暂无数据</div>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import resize from './mixins/resize'
  export default {
    name: "FszBar",
    mixins: [resize],
    props: {
      data: {
        default() {
          return {
            chartBarData: [
              {
                name: "折线1",
                color: "#3186FF",
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              },
              {
                name: "折线2",
                color: "#FF9609",
                data: [108, 125, 148, 136, 99, 87, 148]
              }
            ],
            chartBarAxis: ['01/01', '01/02', '01/03', '01/04', '01/05', '01/06', '01/07'],
          }
        }
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '350px'
      },
      yAxisName: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        chart: null,
        showChart: true,
        option: {
          color: ['#589DFF', '#FC7D6A', '#30C28D', '#FAC000'],
          // title: {
          //   text: '',
          //   textStyle: {
          //     color: '#222222',
          //     fontSize: 14,
          //     lineHeight: 20
          //   },
          //   left: 24,
          //   top: 0
          // },
          // tooltip: {
          //   trigger: 'axis',
          //   backgroundColor: 'rgba(255,255,255,0.9)',
          //   axisPointer: {
          //     type: 'shadow'
          //   },
          //   textStyle: {
          //     fontSize: 12,
          //     color: '#7D7D7D',
          //     lineHeight: 20
          //   },
          //   padding: 12
          // },
          grid: {
            left: 24,
            right: 24,
            bottom: 30,
            top:10,
            containLabel: true
          },
          legend: {
            show: true,
            right: 0,
            left: 0,
            icon: 'rect',
            itemWidth: 8,
            itemHeight: 8,
            // top: 0,
            // itemHeight: '5',
            // itemGap: 26,
            textStyle: {
              fontSize: 12,
              color: '#757575',
              fontWeight: 400,
              lineHeight: 20
            },
            data: []
          },
          xAxis: {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            splitLine: { show: false }, //去除网格线
            splitArea: { show: false }, //保留网格区域
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#D8E0EC', //左边线的颜色
                width: '1' //坐标线的宽度
              }
            },
            axisLabel: {
              interval:0,
              textStyle: {
                color: '#9195A3',
                fontSize:10,
              }
            }
          },
          yAxis: {
            type: 'value',
            // name: this.yAxisName,
            // splitLine: {
            //   show: true,
            //   lineStyle: {
            //     color: '#eeeeee',
            //     height: 1
            //   }
            // },
            // axisLine: {
            //   show: false  //隐藏y轴线
            // },
            // axisTick: {
            //   show: false
            // },
            // nameTextStyle: {
            //   color: 'red',
            //   fontSize: '12',
            //   lineHeight: 22,
            //   fontWeight:500,
            //   padding: [0, 0, 20, 0]
            // },
            splitLine: { show: false }, //去除网格线
            splitArea: { show: false }, //保留网格区域
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: 'none',
                width: '1'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#9195A3',
                fontSize: 10
              }
            }
          },
          // dataZoom: [
          //     {
          //         show: true,
          //         start: 94,
          //         end: 100
          //     },
          //     {
          //         type: 'inside',
          //         start: 94,
          //         end: 100
          //     },
          //     {
          //         show: true,
          //         yAxisIndex: 0,
          //         filterMode: 'empty',
          //         width: 30,
          //         height: '80%',
          //         showDataShadow: false,
          //         left: '93%'
          //     }
          // ],
          series: []
        }
      }
    },
    computed: {
      id() {
        return (
          'pieChart' + new Date().getTime() + Math.round(Math.random() * 100)
        )
      },
    },
    created() {

    },
    watch: {
      data: {
        deep: true,
        handler(newVal, oldVal) {
          console.log("newVal：", newVal)
          console.log("reload line chart")
          if (newVal.chartBarAxis.length) {
            this.showChart = true
            this.initChart()
          } else {
            this.showChart = false
          }
        }
      }
    },
    mounted() {
      // this.$nextTick(() => {
      //   this.initChart()
      // })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      initChart() {
        this.option.series = this.keyParams().series
        this.option.legend.data = this.keyParams().legend
        this.option.xAxis.data = this.data.chartBarAxis
        if (this.option.legend.data.length > 1) {
          this.option.legend.show = true
        }
        this.chart = echarts.init(document.getElementById(this.id))
        this.chart.setOption(this.option, true)
      },

      keyParams() {
        const p = {
          legend: [],
          series: [],
          color: []
        }
        this.data.chartBarData.forEach(el => {
          p.color.push(el.color),
            p.legend.push({
              name: el.name,
              textStyle: {
                color: '#666666'
              }
            })
          p.series.push({
            type: 'bar',
            name: el.name,
           
            // stack: "总量",
            // barMaxWidth: 25,
            barWidth: 16,
            showAllSymbol: true,
            itemStyle: {
              normal: {
                // color: el.color,
                barBorderRadius: [5, 5, 0, 0],
                borderWidth: '3',
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: "#676FFF" // 0% 处的颜色
                }, {
                  offset: 1,
                  color: "#4B84FF" // 100% 处的颜色
                }], false),
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  distance:0,
                  textStyle: { //数值样式
                    color: '#4B84FF',
                    fontSize: 10
                  }
                }
              }
            },
            // lineStyle: {
            //   normal: {
            //     color: el.color,
            //     width: '2'
            //   }
            // },
            // areaStyle: {
            //   normal: {
            //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //       {
            //         offset: 0,
            //         color: el.color
            //       },
            //       {
            //         offset: 1,
            //         color: '#ffffff'
            //       }
            //     ]),
            //     opacity: '0.1'
            //   }
            // },
            data: el.data
          })
        })
        return p
      },
      delPositiveLable(val) {
        return val.toString().replace(/\-/, '')
      }
    }
  }
</script>
<style scoped>
  * {
    margin: 0;
  }

  .module-box {
    position: relative;
  }

  .chart-box {
    position: relative;
    height: 100%;
  }

  .no-data {
    font-size: 14px;
    font-weight: 400;
    color: rgba(111, 111, 111, 1);
    line-height: 20px;
  }
</style>